export const PLANS = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    priceLabel: '$0',
    period: 'forever',
    features: [
      '3 projects',
      '5 team members',
      '2 guests',
      'Basic feedback tools',
      'Community support',
    ],
    cta: 'Get Started Free',
    popular: false,
  },
  {
    id: 'starter',
    name: 'Starter',
    price: 12,
    priceLabel: '$12',
    period: '/month',
    features: [
      '15 projects',
      '25 team members',
      '10 guests',
      'Guest review links',
      'Slack integration',
      'Activity log',
      'Email support',
    ],
    cta: 'Start Free Trial',
    popular: false,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 29,
    priceLabel: '$29',
    period: '/month',
    features: [
      'Unlimited projects',
      'Unlimited members',
      '50 guests',
      'Priority support',
      'Slack, Jira & Discord',
      'Version history',
      'Activity log',
      'Advanced sharing',
    ],
    cta: 'Start Free Trial',
    popular: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: null,
    priceLabel: 'Custom',
    period: '',
    features: [
      'Everything in Pro',
      'Dedicated support',
      'Custom integrations',
      'SLA guarantee',
      'SSO & security',
      'Custom onboarding',
    ],
    cta: 'Contact Sales',
    popular: false,
  },
];
